<template>
   <div class="flex h-100">
      <div class="login-content container-mobile">
         <div class="logo-container">
            <img src="/img/logo.png" alt="Logo BeePerf" />
         </div>
         <div class="register-container">
            <div class="card" style="border-radius:5px;">
               <div class="card-header" style="background-color:#024A98;border-radius:5px 5px 0 0;">
                  <div class="card-header-title" style="color:white">S'enregister</div>
               </div>
               <div class="card-content">
                  <b-message type="is-danger" v-if="message">{{ message }}</b-message>
                  <form @submit.prevent="register()">
                     <b-field label="Nom ou raison sociale" :type="form.errors.has('nom') ? 'is-danger' : ''" :message="form.errors.get('nom')">
                        <b-input v-model="form.nom"></b-input>
                     </b-field>
                     <b-field label="E-mail" :type="form.errors.has('email') ? 'is-danger' : ''" :message="form.errors.get('email')">
                        <b-input type="email" v-model="form.email"></b-input>
                     </b-field>
                     <b-field label="Mot de passe" :type="form.errors.has('password') ? 'is-danger' : ''" :message="form.errors.get('password')">
                        <b-input type="password" v-model="form.password" password-reveal></b-input>
                     </b-field>
                     <b-field label="Confirmer le mot de passe" :type="form.errors.has('password') ? 'is-danger' : ''" :message="form.errors.get('password')">
                        <b-input type="password" v-model="form.password_confirmation" id="password-confirm" password-reveal></b-input>
                     </b-field>

                     <div class="flex" style="justify-content: space-between; padding-top:15px;">
                        <div><b-button native-type="submit" type="is-primary" :loading="loading">Créer le compte</b-button></div>
                        <router-link :to="{ name: 'login' }"><b-button native-type="submit" type="is-light">J'ai déjà un compte</b-button></router-link>
                     </div>
                  </form>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { Form } from 'vform';
export default {
   name: 'Register',
   data() {
      return {
         form: new Form({
            nom: '',
            email: '',
            password: '',
            adresse: '',
            code_postal: '',
            ville: ''
         }),
         loading: false,
         message: this.$route.params.message || ''
      };
   },
   methods: {
      register() {
         this.loading = true;
         this.form.post('/register').then(() => {
            this.$store.dispatch('login', {
               username: this.form.email,
               password: this.form.password
            });
         });
      }
   }
};
</script>
